import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAZ4TxSLU5fp2rgTCRJSkOYPq0JmTlCO1M",
  authDomain: "eau-group.firebaseapp.com",
  projectId: "eau-group",
  storageBucket: "eau-group.firebasestorage.app",
  messagingSenderId: "746755403995",
  appId: "1:746755403995:web:207df2318c77bcf7a85cfe",
};

const app = initializeApp(firebaseConfig);
let messaging = null;

// Initialize messaging only if supported
try {
  messaging = getMessaging(app);
  // console.log("✅ Firebase Messaging initialized");
} catch (error) {
  // console.error("❌ Firebase Messaging not supported:", error);
}

export { messaging };

/**
 * Check if notifications are supported
 */
export const isNotificationSupported = () => {
  return (
    "Notification" in window &&
    "serviceWorker" in navigator &&
    messaging !== null
  );
};

/**
 * Request notification permission and get FCM token
 */
export const requestNotificationPermission = async () => {
  try {
    if (!isNotificationSupported()) {
      // console.log("⚠️ Notifications not supported on this device");
      return null;
    }

    const permission = await Notification.requestPermission();
    // console.log("🔔 Permission status:", permission);

    if (permission === "granted") {
      // console.log("✅ Notification permission granted");

      // Register service worker
      let registration;
      try {
        registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
          {
            scope: "/",
          },
        );
        // console.log("✅ Service Worker registered:", registration.scope);

        // Wait for service worker to be ready
        await navigator.serviceWorker.ready;
        // console.log("✅ Service Worker ready");
      } catch (error) {
        // console.error("❌ Service Worker registration failed:", error);
        return null;
      }

      // Get FCM token
      try {
        const token = await getToken(messaging, {
          vapidKey:
            "BMryv7nrSbZHlGgoLNgCvW7YM_nnic55n8uG30ADZW5WUXOkEnNljlnZ0LH2GQEynxRwvVEo_EsS7H2T0kGICdY",
          serviceWorkerRegistration: registration,
        });

        if (token) {
          // console.log("🔑 FCM Token obtained:", token.substring(0, 20) + "...");
          return token;
        } else {
          // console.log("⚠️ No registration token available");
          return null;
        }
      } catch (error) {
        // console.error("❌ Error getting FCM token:", error);
        return null;
      }
    } else if (permission === "denied") {
      // console.log("❌ Notification permission denied");
      return null;
    } else {
      // console.log("⚠️ Notification permission dismissed");
      return null;
    }
  } catch (error) {
    // console.error("❌ Error requesting notification permission:", error);
    return null;
  }
};
export const setupForegroundListener = (onMessageReceived) => {
  if (!isNotificationSupported() || !messaging) {
    // console.log("⚠️ Cannot setup foreground listener - not supported");
    return () => {};
  }

  const unsubscribe = onMessage(messaging, (payload) => {
    // console.log("📬 Foreground message received:", payload);

    const title =
      payload.notification?.title || payload.data?.title || "New Notification";
    const body = payload.notification?.body || payload.data?.body || "";

    // Get absolute icon URL
    const iconUrl = window.location.origin + "/logo192.png";
    const badgeUrl = window.location.origin + "/badge.png";

    // console.log("🖼️ Using icon:", iconUrl);

    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification(title, {
          body: body,
          icon: iconUrl, // FIXED: Use absolute URL
          badge: badgeUrl, // FIXED: Use absolute URL
          tag: payload.data?.type || "default",
          data: payload.data,
          vibrate: [200, 100, 200],
          requireInteraction: false,
        });
      });
    } else {
      if (Notification.permission === "granted") {
        new Notification(title, {
          body: body,
          icon: iconUrl, // FIXED: Use absolute URL
          badge: badgeUrl, // FIXED: Use absolute URL
          tag: payload.data?.type || "default",
          data: payload.data,
        });
      }
    }

    if (onMessageReceived) {
      onMessageReceived(payload);
    }
  });

  // console.log("✅ Foreground listener setup complete");
  return unsubscribe;
};
